<template>
  <div :data-field-group-name="data.visibility !== 'hidden' ? data.tag : ''">
    <div :class="[this.icon && this.icon.selected ? 'input-group mb-3' : 'form-group']" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel" :class="{'d-block w-100': this.showLabel && this.icon && this.icon.selected }"> {{label}} </label>
      <div class="input-group-prepend" v-if="this.icon && this.icon.selected && this.icon.position === 'left'">
        <span class="input-group-text"><i :class="this.$addIconPrefix(this.icon.selected)"></i></span>
      </div>
      <input class="form-control" :required="required" v-model="value" :placeholder="placeholder" v-show="!this.area"
             :name="this.data.tag" :type="[this.pass == true ? 'password':'text']" :validation="validation"/>
      <textarea class="form-control" :required="required" v-model="value" :placeholder="placeholder"
                v-show="this.area" :name="this.data.tag"></textarea>
      <div class="input-group-prepend" v-if="this.icon && this.icon.selected && this.icon.position === 'right'">
        <span class="input-group-text"><i :class="this.$addIconPrefix(this.icon.selected)"></i></span>
      </div>
      <small class="form-text text-muted" style="width: 100%" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputFieldMailingBoss',
  props: ['label', 'value', 'data', 'area', 'showPlaceholder', 'showLabel', 'icon', 'pass', 'validation'],
  data() {
    return {};
  },
  computed: {
    placeholder() {
      return this.showPlaceholder ? this.label : '';
    },
    required() {
      return this.data.required === 'yes';
    }
  }
};
</script>
<style scoped>
  textarea:not(.form-control-textarea-has-height) {
    resize: none;
  }

  .input-group-text {
    padding: 0 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/Fields/Text.vue